import React, { useState } from "react";
import logo from "../../@assets/edflix.svg";
import homebanner from "../../@assets/homebanner2.jpg";
import joinBtn from "../../@assets/joinButton2.svg";
import { FaCheckCircle } from "react-icons/fa";
import getStartedImage from "../../@assets/getStarted.svg";
import security from "../../@assets/security.svg";
import advantage from "../../@assets/AdvatageAgency.svg";
import footerLogo from "../../@assets/footer_logo.svg";
import socialLinks from "../../@assets/Social Links.svg";
import AgencyStepsCarousel from "../../components/AgencyStepsCarousel";
import amplifyBtn from "../../@assets/Amplify.svg";
import { useNavigate } from "react-router-dom";




const AgencyHomePage = () => {

  const Navigate = useNavigate();
  const [destinationCurrency, setDestinationCurrency] = useState("");
  const [destinationAmount, setDestinationAmount] = useState("");

  const handleProceed = (e) => {
    e.preventDefault();
    Navigate(`/form`);
  }

  return (
    <>
      <div className="d-flex flex-column min-vh-100 position-relative rounded-bottom-4">
        {/* Navigation Bar */}
        <nav
          className="navbar navbar-expand-lg navbar-light py-3 px-3 position-fixed top-0 start-0 w-100"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(5px)",
            zIndex: 10,
          }}
        >
          <div className="container-fluid d-flex justify-content-between align-items-center">
            <img src={logo} alt="logo" />
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
              <a
                href="#"
                className="text-dark fw-bold mx-2 text-decoration-none"
              >
                University
              </a>
              <span className="mx-2">|</span>
              <a href="#" className="text-dark mx-2 text-decoration-none">
                Agency
              </a>
            </div>
            <button
              className="bg-white rounded-3 px-4 py-2 fw-bold opacity-75"
              style={{ fontSize: "0.9rem" }}
            >
              Get Started
            </button>
          </div>
        </nav>

        {/* Main Content */}
        <div className="d-flex flex-grow-1 position-relative ">
          {/* Right Section with Gradient Overlay and Image */}
          <div className="position-relative p-0 w-100">
            <img
              src={homebanner}
              alt="homebanner"
              className="img-fluid h-100 w-100 position-absolute top-0 start-0"
              style={{ objectFit: "cover", zIndex: 0 }}
            />
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background:
                  "linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 0) 70%)",
                zIndex: 1,
              }}
            ></div>
            {/* Text Content Over Image */}
            <div
              className="position-absolute top-50 start-0 translate-middle-y p-5"
              style={{
                zIndex: 2,
                width: "50%",
                whiteSpace: "nowrap", // Ensures text stays on one line
                color: "#000",
              }}
            >
              <h2 className="fw-bold display-4" style={{ color: "#000 " }}>
                Supercharge{" "}
                <span style={{ color: "#7F56D9" }}>Your Agency</span>
              </h2>
              <h5 className="text-secondary opacity-75 mt-3">
                Unify Universities, Simplify Payments, Accelerate Growth
              </h5>
              <button className="btn border-0 bg-transparent pt-4">
                <img src={joinBtn} width={150} alt="Join Now Button" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            <img
              src={advantage}
              alt="advantage"
              className="img-fluid w-100"
              style={{ objectFit: "contain" }}
            />
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="mt-5 container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 text-center">
              <img
                src={security}
                alt="security"
                className="img-fluid w-50"
                style={{ maxWidth: "500px", objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="py-5 mt-5" style={{ background: "#FFF4E3" }}>
        {/* SECOND COMPONENT */}
        <div
          className="rounded-4 py-5 mx-3 "
          style={{ background: "rgba(251, 182, 141, 1)" }}
        >
          <div className="d-flex justify-content-around">
            <div className="d-flex align-items-center">
              <ul className="list-unstyled">
                <li className="border  py-4 rounded-3 my-3 bg-white">
                  <div className="d-flex gap-3 px-3 ">
                    <FaCheckCircle className="my-auto text-success" />
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Pre-arrival financial setup
                    </span>
                  </div>
                </li>
                <li className="border  py-4 rounded-3 my-3 bg-white">
                  <div className="d-flex gap-3 px-3">
                    <FaCheckCircle className="my-auto text-success" />
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Low-fee international transfers
                    </span>
                  </div>
                </li>
                <li className="border  py-4 rounded-3 my-3 bg-white">
                  <div className="d-flex gap-3 px-3">
                    <FaCheckCircle className="my-auto text-success " />{" "}
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Branded, familiar payment experience
                    </span>
                  </div>
                </li>
                <li className="border  py-4 rounded-3 my-3 bg-white">
                  <div className="d-flex gap-3 px-3">
                    <FaCheckCircle className="my-auto text-success" />
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Instant fund access upon arrival
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <div className="card bg-light shadow-sm rounded-3 p-4">
                <div className="card-body">
                  <form onSubmit={handleProceed}>
                    <h5
                      className="card-title text-center text-primary fw-semibold mb-4"
                      style={{ color: "#0056b3" }}
                    >
                      Check Exchange Rate
                    </h5>

                    <div className="mb-3">
                      <label
                        htmlFor="currency"
                        className="form-label text-secondary"
                        style={{ color: "#343a40" }}
                      >
                        Select Currency
                      </label>
                      <select
                        id="currency"
                        className="form-select border-0 shadow-sm"
                        name="destination_currency"
                        required
                        style={{
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          color: "#343a40",
                        }}
                        value={destinationCurrency}
                        onChange={(e) => setDestinationCurrency(e.target.value)}
                      >
                        <option value="">Choose currency</option>
                        <option value="USD">USD - US Dollar</option>
                        <option value="AUD">AUD - Australian Dollar</option>
                        <option value="SGD">SGD - Singapore Dollar</option>
                        <option value="CAD">CAD - Canadian Dollar</option>
                        <option value="GBP">GBP - British Pound</option>
                        <option value="EURO">EURO - Euro</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="amount"
                        className="form-label text-secondary"
                        style={{ color: "#343a40" }}
                      >
                        Enter Amount
                      </label>
                      <input
                        id="amount"
                        type="number"
                        className="form-control border-0 shadow-sm"
                        name="destination_amount"
                        placeholder="Enter amount"
                        required
                        style={{
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          color: "#343a40",
                        }}
                        value={destinationAmount}
                        onChange={(e) => setDestinationAmount(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      <p
                        className="text-secondary mb-1"
                        style={{ color: "#343a40" }}
                      >
                        Applied Charges
                      </p>
                      <div className="p-3 rounded-3 bg-white shadow-sm">
                        <ul className="list-unstyled mb-0">
                          <li className="d-flex justify-content-between">
                            <span style={{ color: "#0056b3" }}>
                              Exchange Rate:
                            </span>
                            <span
                              className="fw-semibold"
                              style={{ color: "#28a745" }}
                            >
                              Fx_rate
                            </span>
                          </li>
                          <li className="d-flex justify-content-between mt-2">
                            <span style={{ color: "#0056b3" }}>Fees:</span>
                            <span
                              className="fw-semibold"
                              style={{ color: "#28a745" }}
                            >
                              Fees
                            </span>
                          </li>
                          <li className="d-flex justify-content-between mt-2">
                            <span style={{ color: "#0056b3" }}>TCS Rate:</span>
                            <span
                              className="fw-semibold"
                              style={{ color: "#28a745" }}
                            >
                              TCS_Rate
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="mb-4">
                      <label
                        className="form-label text-secondary"
                        style={{ color: "#343a40" }}
                      >
                        Amount in INR
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control border-0 shadow-sm me-2"
                          value="INR"
                          disabled
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "#f8f9fa",
                            color: "#343a40",
                          }}
                        />
                        <input
                          type="text"
                          className="form-control border-0 shadow-sm"
                          placeholder="Equivalent amount"
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "#f8f9fa",
                            color: "#343a40",
                          }}
                        />
                      </div>
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-success px-4 py-2"
                        style={{
                          borderRadius: "12px",
                          backgroundColor: "#28a745",
                          border: "none",
                          color: "#fff",
                        }}
                      >
                        Proceed
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* THIRD COMPONENT */}
        <AgencyStepsCarousel />
        <div
          className="border w-75 rounded-4 py-4 m-auto bg-white mt-5"
          style={{ position: "relative" }}
        >
          {/* Eclipse on Top-Left */}
          <div
            style={{
              width: "312px",
              height: "312px",
              backgroundColor: "#7F56D966",
              borderRadius: "50%",
              position: "absolute",
              top: "-156px",
              left: "-156px",
              opacity: 0,
            }}
          ></div>

          {/* Eclipse on Bottom-Right */}
          <div
            style={{
              width: "312px",
              height: "312px",
              backgroundColor: "#7F56D966",
              borderRadius: "50%",
              position: "absolute",
              bottom: "-156px",
              right: "-156px",
              opacity: 0,
            }}
          ></div>

          <div className="text-center my-4">
            <h4
              style={{
                // fontFamily: "Satoshi",
                fontSize: "40px",
                fontWeight: "500",
                lineHeight: "72px",
                letterSpacing: "-0.01em",
                textAlign: "center",
                padding: "0% 3% 0% 3%",
              }}
            >
              Focus on Growing Your Agency: Let Eddflix Handle the Complex
              Financial Processes.
            </h4>
            <button className="btn border-0 bg-transparent pt-4">
              <img src={amplifyBtn} width={250} alt="Join Now Button" />
            </button>
          </div>
        </div>
      </div>

      <div
        className="px-5 rounded-top-4 "
        style={{
          background:
            "radial-gradient(39.54% 39.54% at 50% 53.06%, #0A035C 0%, #160F61 28.13%, #09072A 100%",
        }}
      >
        <div className="py-4">
          {/* FIRST ROW */}
          <div className="text-white text-center w-50 m-auto p-5 py-4 ">
            <h4>
              Join Eddflix & harness the power of education to "change the
              world, one payment at a time"
            </h4>
          </div>
          {/* SECOND ROW */}
          <div className="text-center mb-3">
            <button
              className="px-4 py-2 rounded-3 border-0 fw-bold"
              style={{ fontSize: "0.8rem" }}
            >
              Start Changing The World
            </button>
          </div>
          {/* THIRD ROW */}
          <div className="d-flex justify-content-between mt-3x">
            <div>
              <img src={footerLogo} alt="footerLogo" />
            </div>
            <div>
              <img src={socialLinks} alt="socialLinks" />
            </div>
          </div>
          {/* FOURTH ROW */}
          <div className="pt-5">
            <ul
              className="d-flex justify-content-center list-unstyled  gap-5 text-white"
              role="button"
            >
              <li className="">
                &copy; {new Date().getFullYear()} All rights reserved.
              </li>
              <li className="text-decoration-none">Privacy Policy</li>
              <li className="text-decoration-none">Terms of Service</li>
              <li className="text-decoration-none">Cookies Settings</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgencyHomePage;
